import { Component, inject } from '@angular/core';
import { GasOilAndLubricantTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GasOilAndLubricantTypeCreateDto,
  GasOilAndLubricantTypeDto,
  GasOilAndLubricantTypeExcelDownloadDto,
  GasOilAndLubricantTypeUpdateDto,
} from '../proxy/general/dtos/gas-oil-and-lubricant-type';
import { GASOILANDLUBRICANTTYPE_CONFIG, GASOILANDLUBRICANTTYPE_FIELDS } from './gas-oil-and-lubricant-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-gas-oil-and-lubricant-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GasOilAndLubricantTypeService, ConfirmationService],
  templateUrl: './gas-oil-and-lubricant-type.html',
  styleUrl: './gas-oil-and-lubricant-type.scss',
})
export class GasOilAndLubricantType extends BaseCrudComponent<
  GasOilAndLubricantTypeDto,
  GasOilAndLubricantTypeCreateDto,
  GasOilAndLubricantTypeUpdateDto,
  GasOilAndLubricantTypeExcelDownloadDto
> {
  service = inject(GasOilAndLubricantTypeService);
  config = GASOILANDLUBRICANTTYPE_CONFIG;
  fields = GASOILANDLUBRICANTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: GasOilAndLubricantTypeDto): GasOilAndLubricantTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GasOilAndLubricantType';
  }
}
